import { render, staticRenderFns } from "./DriverDocuments.vue?vue&type=template&id=3fa32d9a&"
import script from "./DriverDocuments.vue?vue&type=script&lang=js&"
export * from "./DriverDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports